module.exports = __webpack_public_path__ + "img/Shopify.27726c1f.png";